<template>
  <div>
    <ActionsMenu
      :actions="actions"
      :options="{
        theme: 'light job-context-menu'
      }"
      @break-job-signature="toggleBreakingSignatureModal"
    />
    <ActionConfirmationModal
      v-if="breakJobSignatureModal"
      :modal-contents="modalContents"
      @hide-modal="toggleBreakingSignatureModal"
    />
  </div>
</template>

<script>
import ActionsMenu from "@/components/ActionsMenu.vue";
import ActionConfirmationModal from "./ActionConfirmationModal.vue";

export default {
  components: {
    ActionsMenu,
    ActionConfirmationModal
  },
  props: {
    links: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      breakJobSignatureModal: false
    };
  },
  computed: {
    actions() {
      return [
        {
          label: "Break Job Signature",
          icon: "fa-regular fa-cut",
          eventName: "break-job-signature",
          className: "menu-item",
          disabled: !this.links.invoice_break
        }
      ];
    },
    modalContents() {
      return {
        message:
          "Breaking the job signature on file will require a new customer signature to be obtained going forward. This change also discards the customer’s validation of the completed work detailed on the invoice.",
        title: "Confirm Break Signature",
        textarea_label: "Add a reason to break this job signature",
        success_message:
          "Job signature successfully broken. Please obtain a new work completed signature from the customer.",
        event_name: "refresh-datatable",
        action_url: this.links.invoice_break
      };
    }
  },
  methods: {
    toggleBreakingSignatureModal() {
      this.breakJobSignatureModal = !this.breakJobSignatureModal;
    }
  }
};
</script>

<style lang="scss"></style>
